import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';

function Videos() {
  const [videos, setVideos] = useState([]);
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({
    youtube_video_id: '', title: '', thumbnail_url: '',
    artist_id: '', is_label_channel: false, published_at: '', is_featured: false,
  });

  const fetchVideos = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin-videos/all');
      setVideos(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchArtists = async () => {
    try {
      const res = await api.get('/artists/public?limit=100');
      setArtists(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchVideos();
    fetchArtists();
  }, []);

  const openCreate = () => {
    setForm({ youtube_video_id: '', title: '', thumbnail_url: '', artist_id: '', is_label_channel: false, published_at: '', is_featured: false });
    setModal({});
  };

  const openEdit = (item) => {
    setForm({
      youtube_video_id: item.youtube_video_id,
      title: item.title || '',
      thumbnail_url: item.thumbnail_url || '',
      artist_id: item.artist_id || '',
      is_label_channel: item.is_label_channel || false,
      published_at: item.published_at ? item.published_at.slice(0, 10) : '',
      is_featured: item.is_featured || false,
    });
    setModal(item);
  };

  const extractYoutubeId = (input) => {
    const trimmed = input.trim();
    const patterns = [
      /youtu\.be\/([a-zA-Z0-9_-]{6,})/,
      /youtube\.com\/watch\?v=([a-zA-Z0-9_-]{6,})/,
      /youtube\.com\/shorts\/([a-zA-Z0-9_-]{6,})/,
      /youtube\.com\/embed\/([a-zA-Z0-9_-]{6,})/,
    ];
    for (const pattern of patterns) {
      const match = trimmed.match(pattern);
      if (match) return match[1];
    }
    return trimmed; // udah berupa ID mentah
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const cleanId = extractYoutubeId(form.youtube_video_id);
      const payload = { ...form, youtube_video_id: cleanId, artist_id: form.artist_id || null };
      if (modal.id) {
        await api.put(`/admin-videos/${modal.id}`, payload);
      } else {
        await api.post('/admin-videos', payload);
      }
      setModal(null);
      await fetchVideos();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan video');
    }
  };

  const setFeaturedOrder = async (id, order) => {
    try {
      await api.patch(`/admin-videos/${id}/featured`, { featured_order: order === '' ? null : parseInt(order) });
      await fetchVideos();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update urutan featured');
    }
  };

  const deleteVideo = async (id) => {
    if (!window.confirm('Hapus video ini?')) return;
    try {
      await api.delete(`/admin-videos/${id}`);
      await fetchVideos();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus video');
    }
  };

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Video Hub</h1>
        <button className="btn-primary" onClick={openCreate}>+ Tambah Video</button>
      </div>
      <p style={{ color: '#888', marginBottom: 20 }}>
        Isi kolom "Urutan Tampil" dengan angka (1 = paling depan). Maks 6 video pertama yang tampil di homepage. Kosongkan untuk tidak jadi prioritas (tetap muncul urut dari tanggal terbaru kalau slot masih ada).
      </p>
      {loading ? (
        <p>Memuat...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Urutan Tampil</th>
                <th>Judul</th>
                <th>Artis</th>
                <th>YouTube ID</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {videos.map((v) => (
                <tr key={v.id}>
                  <td>
                    <input
                      type="number"
                      min="1"
                      defaultValue={v.featured_order || ''}
                      placeholder="-"
                      style={{ width: 60, padding: '4px 8px', fontSize: 13 }}
                      onBlur={(e) => setFeaturedOrder(v.id, e.target.value)}
                    />
                  </td>
                  <td>{v.title || '-'}</td>
                  <td>{v.artist_name || (v.is_label_channel ? 'Saskara Record' : '-')}</td>
                  <td>
                    <a href={`https://youtube.com/watch?v=${v.youtube_video_id}`} target="_blank" rel="noreferrer" style={{ color: '#C9A66B' }}>
                      {v.youtube_video_id}
                    </a>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-edit" onClick={() => openEdit(v)}>Edit</button>
                      <button className="btn-delete" onClick={() => deleteVideo(v.id)}>Hapus</button>
                    </div>
                  </td>
                </tr>
              ))}
              {videos.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', color: '#888' }}>
                    Belum ada video
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitForm}>
            <h2>{modal.id ? 'Edit Video' : 'Tambah Video Baru'}</h2>
            <input
              type="text"
              placeholder="Link YouTube (bisa paste URL lengkap atau ID doang)"
              value={form.youtube_video_id}
              onChange={(e) => setForm({ ...form, youtube_video_id: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Judul video"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
            />
            <input
              type="url"
              placeholder="URL thumbnail custom (opsional, default pakai thumbnail YouTube)"
              value={form.thumbnail_url}
              onChange={(e) => setForm({ ...form, thumbnail_url: e.target.value })}
            />
            <select value={form.artist_id} onChange={(e) => setForm({ ...form, artist_id: e.target.value })}>
              <option value="">-- Tanpa artis spesifik --</option>
              {artists.map((a) => (
                <option key={a.id} value={a.id}>{a.name}</option>
              ))}
            </select>
            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 8 }}>Tanggal Publish Video</label>
            <input
              type="date"
              value={form.published_at}
              onChange={(e) => setForm({ ...form, published_at: e.target.value })}
            />
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
              <input
                type="checkbox"
                checked={form.is_label_channel}
                onChange={(e) => setForm({ ...form, is_label_channel: e.target.checked })}
              />
              Video dari channel resmi Saskara Record (bukan artis individu)
            </label>
            <p style={{ fontSize: 12, color: '#888', marginTop: 8 }}>
              Atur urutan tampil di homepage lewat kolom "Urutan Tampil" di tabel setelah video ini disimpan.
            </p>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setModal(null)}>Batal</button>
              <button type="submit" className="btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Videos;
